module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a2d061492bb48170f51a2f436b866a80.png";